<div class="bs-tabs-wrapper" [ngClass]="tabsClass">
  <!-- Tab List (Navigation) -->
  <ul class="nav nav-tabs" 
      role="tablist">
    <li *ngFor="let tab of tabs; let i = index; trackBy: trackByTab"
        role="presentation"
        [class.active]="tab.active"
        [class.disabled]="tab.disabled">
      <a [id]="getTabId(i)"
        [attr.href]="getTabHref(i)"
        [attr.aria-selected]="tab.active"
        [attr.aria-controls]="getTabPanelId(i)"
        [attr.aria-disabled]="tab.disabled || null"
        [attr.aria-label]="getAriaLabel(tab)"
        [attr.title]="tab.title"
        [class]="tab.tabClass"
        [tabindex]="tab.disabled ? -1 : (tab.active ? 0 : -1)"
        role="tab"
        (click)="selectTab(tab, i, $event)"
        (keydown)="onKeyDown($event, i)">
        
        <!-- Optional Icon -->
        <i *ngIf="tab.icon" 
           [ngClass]="tab.icon" 
           aria-hidden="true"></i>
        
        <!-- Tab Label -->
        <span>{{ tab.label }}</span>
        
        <!-- Optional Badge -->
        <span *ngIf="tab.badge" 
              class="badge"
              [ngClass]="tab.badgeClass"
              aria-hidden="true">{{ tab.badge }}</span>
      </a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content" [ngClass]="contentClass">
    <div *ngFor="let tab of tabs; let i = index; trackBy: trackByTab"
         [id]="getTabPanelId(i)"
         class="tab-pane"
         [class.active]="tab.active"
         [attr.aria-labelledby]="getTabId(i)"
         [attr.aria-hidden]="!tab.active"
         role="tabpanel">
      <!-- Template-based lazy loading: Deferred initialization until first visit -->
      <ng-container *ngIf="tab.lazy && tab.lazyContent">
        <ng-container *ngIf="tab._hasBeenInstantiated">
          <ng-container *ngTemplateOutlet="tab.lazyContent"></ng-container>
        </ng-container>
      </ng-container>
      
      <!-- Content projection lazy loading: Instantiates on first visit, persists -->
      <ng-container *ngIf="tab.lazy && !tab.lazyContent">
        <ng-container *ngIf="tab._hasBeenInstantiated">
          <ng-container *ngTemplateOutlet="tab.content"></ng-container>
        </ng-container>
      </ng-container>
      
      <!-- Eager loading: Always instantiate, show/hide with CSS -->
      <ng-container *ngIf="!tab.lazy">
        <ng-container *ngTemplateOutlet="tab.content"></ng-container>
      </ng-container>
    </div>
  </div>
</div>
